import { AiOutlineSwap } from 'react-icons/ai'
import {
  Button,
  HStack,
  Image,
  Link as ChakraLink,
  Tag,
  Text,
  Tooltip,
  VStack,
} from '@chakra-ui/react'
import { IOrder } from 'models/Order.model'
import { NEVER_EXPIRY } from 'modules/order/constants'
import Link from 'next/link'
import { FormatDate, formatDate, getDateFromNow } from 'utils/date/dateFormat'
import { getChainIcon, getChainName } from 'utils/web3/chains'

export const OrderItem = ({
  order: {
    _id,
    chainId,
    sellAmount,
    buyAmount,
    sellTokenSymbol,
    buyTokenSymbol,
    buyTokenDecimals,
    sellTokenDecimals,
    ttl,
  },
}: {
  order: IOrder
}) => {
  const expiry = new Date(ttl).getTime()
  return (
    <Link key={_id?.toString()} href={`/trade/${_id?.toString()}`} passHref>
      <ChakraLink
        _hover={{ textDecoration: 'none' }}
        _focus={{ outline: 'none' }}
      >
        <Button
          as={HStack}
          justifyContent="space-between"
          alignItems="center"
          py={3}
          h="fit-content"
          w="full"
          _focus={{ outline: 'none' }}
        >
          <VStack alignItems="flex-start">
            <Text pr={1}>
              {`Trade ${sellTokenSymbol} for ${buyTokenSymbol}`}
            </Text>
            <HStack alignItems="center">
              <Tag colorScheme="blue">
                {`${sellTokenSymbol} ${
                  Math.floor(
                    (Number(sellAmount) / 10 ** (sellTokenDecimals + 6)) *
                      10 ** (6 + 5)
                  ) /
                  10 ** 5
                }`}
              </Tag>
              <AiOutlineSwap color="#2172e5" size="12px" />
              <Tag colorScheme="blue">
                {`${buyTokenSymbol} ${
                  Math.floor(
                    (Number(buyAmount) / 10 ** (buyTokenDecimals + 6)) *
                      10 ** (6 + 5)
                  ) /
                  10 ** 5
                }`}
              </Tag>
            </HStack>
            {expiry === NEVER_EXPIRY ? (
              <Text color="muted" fontSize="sm">
                Never expires
              </Text>
            ) : (
              <Text color="muted" fontSize="sm">
                Expires on {formatDate(expiry, FormatDate.Short)}
                {' - '}
                {getDateFromNow(expiry)}
              </Text>
            )}
          </VStack>
          <Tooltip label={getChainName(chainId)} hasArrow placement="right">
            <Image src={getChainIcon(chainId)} w={4} alt={'Network'} />
          </Tooltip>
        </Button>
      </ChakraLink>
    </Link>
  )
}

export default OrderItem
